import cn from 'classnames';

import { Typography } from '@sravni/react-design-system';

import styles from './styles.module.scss';

const { Text, Heading } = Typography;

type Props = {
  title: string;
  subTitle: string | JSX.Element;
  className?: string;
};

export const HeaderTitle = ({ title, subTitle, className }: Props) => (
  <div className={cn(styles.wrapper, className)}>
    <Heading className="h-color-D100" level={2}>
      {title}
    </Heading>
    <Text className="h-color-D60 h-pt-8" size={14}>
      {subTitle}
    </Text>
  </div>
);
